import { CircularProgress } from '@mui/material';
import { CheckCircle, XCircle } from 'phosphor-react';

import { TxStatus } from '~components/providers/types';
import { secondaryColors, statusRed } from '~components/theme/styles/colors';

type TransactionNotificationIconProps = {
  status?: TxStatus;
  isTransacting?: boolean;
  size?: number;
};

export const TransactionNotificationIcon: React.FC<TransactionNotificationIconProps> = ({
  status,
  isTransacting,
  size = 16,
}) => {
  let transactionIcon = null;
  if (isTransacting) {
    transactionIcon = <CircularProgress color="secondary" size={size} />;
  } else if (status === TxStatus.error) {
    transactionIcon = <XCircle color={statusRed[100]} size={size} />;
  } else {
    transactionIcon = <CheckCircle color={secondaryColors[200]} size={size} />;
  }
  return transactionIcon;
};
